import { API_TAGS } from '@/shared/api/api-tags';
import { baseApi } from '@/shared/api/base-api';

import type {
  AppSettings,
  UpdateSettingsRequest,
} from '../types/settings.types';

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<AppSettings, undefined>({
      query: () => '/settings',
      providesTags: [API_TAGS.Settings],
    }),

    updateSettings: builder.mutation<AppSettings, UpdateSettingsRequest>({
      query: (body) => ({
        url: '/settings',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [API_TAGS.Settings],
    }),
  }),
});

export const { useGetSettingsQuery, useUpdateSettingsMutation } = settingsApi;
